export default function ContactSection() {
  return (
    <section id="contact" className="py-16 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-3xl mx-auto">
        <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 text-center">
          联系我们
        </h2>
        <p className="mt-3 text-foreground-500 text-sm md:text-base text-center">
          如有任何问题或建议，欢迎通过以下方式与我们取得联系
        </p>
        <div className="mt-8 grid grid-cols-1 sm:grid-cols-3 gap-5">
          <div className="bg-background-100 rounded-xl p-6 text-center border border-background-200 cursor-default">
            <div className="w-12 h-12 mx-auto flex items-center justify-center rounded-full bg-primary-100 text-primary-500">
              <i className="ri-mail-line text-xl"></i>
            </div>
            <h3 className="mt-4 text-sm font-bold text-foreground-900">商务合作</h3>
            <p className="mt-1 text-xs text-foreground-500">business@jinrikankan.com</p>
          </div>
          <div className="bg-background-100 rounded-xl p-6 text-center border border-background-200 cursor-default">
            <div className="w-12 h-12 mx-auto flex items-center justify-center rounded-full bg-accent-100 text-accent-500">
              <i className="ri-chat-smile-2-line text-xl"></i>
            </div>
            <h3 className="mt-4 text-sm font-bold text-foreground-900">内容投稿</h3>
            <p className="mt-1 text-xs text-foreground-500">contribute@jinrikankan.com</p>
          </div>
          <div className="bg-background-100 rounded-xl p-6 text-center border border-background-200 cursor-default">
            <div className="w-12 h-12 mx-auto flex items-center justify-center rounded-full bg-secondary-100 text-secondary-600">
              <i className="ri-question-answer-line text-xl"></i>
            </div>
            <h3 className="mt-4 text-sm font-bold text-foreground-900">用户反馈</h3>
            <p className="mt-1 text-xs text-foreground-500">feedback@jinrikankan.com</p>
          </div>
        </div>
      </div>
    </section>
  );
}